import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'UnlinkProfile',
  properties: {
    customerId: prop(String),
  },
});
